<template>
  <MultiLegForm />
</template>

<script setup lang="ts">
import MultiLegForm from "./MultiLegForm.vue";
</script>

<style scoped></style>
